<template>
  <div id="app">
    <MediaSelector />
  </div>
</template>

<script>
import MediaSelector from './components/MediaSelector.vue'

export default {
  name: 'App',
  components: {
    MediaSelector
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: #fff;
  min-height: 100vh;
  color: #000;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}
</style>
